import React, { useRef, useState, useEffect } from "react";
import {
  SearchOutlined,
  CheckCircleFilled,
  UserOutlined,
  SmileOutlined,
  BellFilled,
  CloseCircleOutlined,
  AppstoreOutlined,
  CloseOutlined,
  LogoutOutlined,
  ArrowLeftOutlined,
  RightCircleOutlined,
  BookOutlined,
  AppstoreFilled,
  HistoryOutlined,
  BitcoinOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Menu,
  Tabs,
  Dropdown,
  Card,
  Button,
  Avatar,
  Badge,
  message,
  theme,
  Input,
  Upload,
  Tooltip,
  Drawer,
  ConfigProvider,
  Radio,
} from "antd";
import { L1, L3, L4 } from "../SvgCollections";

import "./TradeRoom.css";
import "./../DynamicSidebar/Side.css";
import logo from "../Assets/logo.webp";
import logoLg from "../Assets/logo.webp";

import singleLogo from "../Assets/singleLogo.png";

import TabsWithAccordionHeader from "./Tabpane";
import TradeLayout from "./TradeLayout";
import TradeHitorySide from "../DynamicSidebar/TradeHitorySide";
import Support from "../DynamicSidebar/Support";
import LeaderBoard from "../DynamicSidebar/LeaderBoard";
import Promo from "../DynamicSidebar/Promo";
import Webinar from "../DynamicSidebar/Webinar";
import { Tutorial } from "../DynamicSidebar/Tutorial";
import { useLayout } from "../Context/LayoutContext";
import { Divider, Space, Tour } from "antd";
import More from "../DynamicSidebar/More";
import Market from "../DynamicSidebar/Market";
import { PaymentMethod } from "../DynamicDrawer/PaymentMethod";
import Axios from "../Axios";
import DropDown from "./DropTesting";
import LayoutDrop from "./LayoutDrop";
import { useTheme } from "../Context/ThemeProvider";
import { motion, AnimatePresence, useAnimation } from "framer-motion";
import { Loader } from "../Loader/Loader";
import OrderBookPanel from "../Components/OrderBook";
import {
  AssetsAddIcon1,
  AssetsAddIcon2,
  CameraIcon,
  ChatIcon,
  CopyIcon,
  DropDownIcon1,
  GridIcon,
  LeaderBoardIcon,
  MarketIcon,
  MoreIcon,
  PromoIcon,
  QuestionIcon,
  SupportIcon,
  ThreebarIcon,
  TotalPortfolioIcon,
  TradingHistoryIcon,
  TutorialsIcon,
  VerifyIcon,
  WebinarsIcon,
} from "../Icons/Icons";
import Footer from "../Components/Footer";
import MobileDrawer from "../Components/MobileDrawer";
import SideMenu from "../Components/SideMenu";
import RightPanel from "../Components/RightPanel";
import { sidebarConfig } from "../sidebarConfig";
import MobileProfileDrawer from "../Components/MobileProfileDrawer";
// import Header from "../Components/Header";
import { AreaChartOutlined, ControlOutlined } from "@ant-design/icons";
import tradeIcon from "../Assets/Trade 1.svg";
import portfolioIcon from "../Assets/Portfolio.svg";
import newsIcon from "../Assets/news_logo.svg";
import binaryIcon from "../Assets/Binary_arrow.svg";
import CryptoIcon from "../Assets/Crypto_logo.svg";
import ForexIcon from "../Assets/forex_logo.svg";
import profileIcon from "../Assets/Me_logo.svg";
import consts from "../consts";

const style = {
  display: "flex",
  flexDirection: "column",
  gap: 8,
  marginBottom: 16,
};

// ant implementation
const { Header, Content, Sider } = Layout;
// const { Content, Sider } = Layout;
const { TabPane } = Tabs;
const { Search } = Input;

const TradeRoom = ({ setOnOff, onOff, tab }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [activeKeyRoom, setActiveKeyRoom] = useState("traderoom");
  const [activeDrawer, setActiveDrawer] = useState("settings");
  const [profileDrop, setProfileDrop] = useState(false);
  const [accDrop, setAccDrop] = useState(false);
  const [loader, setLoader] = useState(false);
  const [noDataScroll, setNoDataScroll] = useState(false);
  const [demoAcc, setDemoAcc] = useState(false);
  const [isTrendingOpen, setIsTrendingOpen] = useState(false);
  const [animKeyCoin, setAnimKeyCoin] = useState(0);
  const [profile, setProfile] = useState({});
  const [imageFile, setImageFile] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [collapsedHistory, setCollapsedHistory] = useState(true);
  const [placement, setPlacement] = useState("bottom");
  const [placementAccount, setPlacementAccount] = useState("right");
  const [openProfile, setOpenProfile] = useState(false);
  const [value, setValue] = useState(1);
  const [openPortfolioDrawer, setOpenPortfolioDrawer] = useState(false);

  const [notifications, setNotifications] = useState([]);
  const [openAccount, setOpenAccount] = useState(false);
  const [valueAccount, setValueAccount] = useState(1);
  const [image, setImage] = useState(null);
  const [animateKey, setAnimateKey] = useState(0);
  const [animKey, setAnimKey] = useState(0); // re-trigger animation on open
  const [showBell, setShowBell] = useState(false);
  const [open, setOpen] = useState(false);
  const [activeComponent, setActiveComponent] = useState(null);

  const [activeTabType, setActiveTabType] = useState(null);
  const [activeMenu, setActiveMenu] = useState("binary"); // default active
  const [type, setType] = useState("crypto");

  const isMobilePoint = window.innerWidth <= 767;

  //context
  const {
    tabs,
    onEdit,
    activeKey,
    setActiveKey,
    activeFtpage,
    showDrawer,
    isRunning,
    isMatched,
    isMatchedIndex,
    wallet,
    setEscrow,
    escrow,
    getWallet,
    onClose,
    mode,
    setMode,
    percent,
    addAsset,
    chartType,
  } = useLayout();

  const { theme, toggleTheme } = useTheme();

  console.log(activeKey, "futurePage");

  /*Tour  */
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);

  // mobile-accont-drawer

  const showDrawerprofile = () => {
    setOpenProfile(true);
  };
  const onChange = (e) => {
    setPlacementAccount(e.target.value);
  };
  const onCloseProfile = () => {
    setOpenProfile(false);
  };

  // mobile-account-drawer

  const onChangeRadio = (e) => {
    setValue(e.target.value);
  };
  const showDrawerAccount = () => {
    setOpenAccount(true);
    onClose();
    setOpenPortfolioDrawer(false);
  };
  const onChangeAccount = (e) => {
    setPlacement(e.target.value);
  };
  const onCloseAccount = () => {
    setOpenAccount(false);
  };
  // const showOrderBookk = () => {
  //   setshowOrderBookk(true);
  //   setCollapsedHistory(false);
  // };
  // const onOrderBookClose = () => {
  //   setshowOrderBookk(false);
  //   setCollapsedHistory(true);
  // };

  const showPortfolioDrawer = () => {
    setOpenPortfolioDrawer(true);
    setCollapsedHistory(false);
  };
  const onPortfolioClose = () => {
    setOpenPortfolioDrawer(false);
    setCollapsedHistory(true);
  };

  useEffect(() => {
    if (!isMobilePoint) {
      setOpenPortfolioDrawer(false);
    }
  }, [isMobilePoint]);

  const tabVariants = {
    hidden: { opacity: 0, x: 15 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
    exit: { opacity: 0, x: -15, transition: { duration: 0.25 } },
  };

  const steps = [
    {
      title: "Real Account Is On",
      description:
        "Click here if you want to change your account type from Real to Practice",

      target: () => ref1.current,
    },
    {
      title: "Asset Selector",
      description: "Save your changes.",
      target: () => ref2.current,
    },
    {
      title: "Multiple Chart Mode",
      description:
        "Here You can choose a multiple chart grid with up to 9 charts on 1 screen",
      target: () => ref3.current,
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991.98);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /*Sidebar nav menu */
  const sideArr = [
    {
      key: "traderoom",
      name: (
        <div className="div-txt">
          TOTAL
          <div>PORTFOUIO</div>
        </div>
      ),
      icon: <TotalPortfolioIcon />,
    },
    // {
    //   key: "tradehistory",
    //   name: (
    //     <div className="div-txt">
    //       TRADING
    //       <div>HISTORY</div>
    //     </div>
    //   ),
    //   icon: <TradingHistoryIcon />,
    // },
    // {
    //   key: "support",
    //   name: (
    //     <div className="div-txt">
    //       CHATS&
    //       <div>SUPPORT</div>
    //     </div>
    //   ),
    //   icon: <ChatIcon />,
    // },
    // {
    //   key: "leaderboard",
    //   name: (
    //     <div className="div-txt">
    //       LEADER
    //       <div>BOARD</div>
    //     </div>
    //   ),
    //   icon: <LeaderBoardIcon />,
    // },
    // {
    //   key: "promo",
    //   name: <div className="div-txt">PROMO</div>,
    //   icon: <PromoIcon />,
    // },
    // {
    //   key: "webinar",
    //   name: <div className="div-txt">WEBINARS</div>,
    //   icon: <WebinarsIcon />,
    // },
    // {
    //   key: "market",

    //   name: (
    //     <div className="div-txt">
    //       MARKET
    //       <div>ANALYSIS</div>
    //     </div>
    //   ),
    //   icon: <MarketIcon />,
    // },
    // {
    //   key: "guide",

    //   name: <div className="div-txt">TUTORIALS</div>,
    //   icon: <TutorialsIcon />,
    // },
    // {
    //   key: "more",

    //   name: <div className="div-txt">MORE</div>,
    //   icon: <MoreIcon />,
    // },
  ];

  const commonProps = {
    loader,
    setCollapsed,
    setNoDataScroll,
    setOpen,
  };

  const multiLayerSidebar = sidebarConfig(commonProps).filter(
    (item) => item.component,
  );

  const getNotifications = async () => {
    try {
      const response = await Axios.post(
        "/notification/getNotification",
        {},
        {
          headers: {
            Authorization: localStorage.getItem("nzanzi"),
          },
        },
      );
      const data = await response?.data;
      console.log(data, "notification");
      if (data?.success && data?.result?.length > 0) {
        setNotifications(data?.result);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      setNotifications([]);
      console.log(error);
    }
  };

  const handleLoading = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  };

  useEffect(() => {
    // Function to check screen width
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991.98);
    };

    handleResize(); // run initially
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClose = async () => {
    try {
      const response = await Axios.post(
        "/notification/updateNotification",
        {},
        {
          headers: {
            Authorization: localStorage.getItem("nzanzi"),
          },
        },
      );
      const data = await response?.data;

      if (data?.success) {
        getNotifications();
      } else {
        getNotifications();
      }
    } catch (error) {
      getNotifications();
      console.log(error);
    }
  };

  const handleMenuClick = (e) => {
    setLoader(true);
    if (e.key === "traderoom") {
      setCollapsed(true);
      setActiveKeyRoom(e.key);
    } else if (activeKeyRoom === e.key) {
      setCollapsed(!collapsed);
      setActiveKeyRoom(e.key);
    } else {
      setCollapsed(false);
      setActiveKeyRoom(e.key);
    }
    const timer = setTimeout(() => {
      setLoader(false);
    }, 1500);

    return () => clearTimeout(timer);
  };

  //upload image

  const props = {
    beforeUpload: (file) => {
      // const reader = new FileReader();
      setImageFile(file);
      // uploadImage();
      // reader.readAsDataURL(file);
      setProfileDrop(false); // ✅ close dropdown after upload

      // reader.onload = (e) => {
      //     // ⏳ Simulate delay
      //     setTimeout(() => {
      //         setImage(e.target.result); // ✅ set image in state
      //         message.success("Uploaded Successfully 🎉");
      //     }, 1000);
      // };

      // ❌ Prevent Ant Design from uploading automatically
      return false;
    },
  };

  /*  header tab */

  // const addTab = () => {
  //     const newKey = `${Date.now()}`;
  //     setTabs([...tabs, { key: newKey, title: "New Tab" }]);
  //     setActiveKey(newKey);
  // };

  // const removeTab = (targetKey) => {
  //     let newActiveKey = activeKey;
  //     const lastIndex = tabs.findIndex(tab => tab.key === targetKey) - 1;
  //     const newTabs = tabs.filter(tab => tab.key !== targetKey);

  //     if (newTabs.length && newActiveKey === targetKey) {
  //         newActiveKey = lastIndex >= 0 ? newTabs[lastIndex].key : newTabs[0].key;
  //     }

  //     setTabs(newTabs);
  //     setActiveKey(newActiveKey);
  // };

  // const onEdit = (targetKey, action) => {
  //     console.log(targetKey, 'targetKey');

  //     if (action === "add") {
  //         addTab();
  //     } else if (action === "remove") {
  //         removeTab(targetKey);
  //     }
  // };

  //Heade tab design

  // Custom tab label for each tab
  const CustomTabLabel = (row, i) => {
    console.log(row, "rowtab");
    const isActive = row.key === activeKey;

    const showLabel = !isMobile || (isMobile && isActive);
    const showCloseIcon = isMobile && tabs.length > 1;

    const handleClose = (e) => {
      e.stopPropagation();
      onEdit(row.key, "remove");
    };
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "5px 25px",
          borderBottom: "2px solid #fff",
        }}
        className={i <= isMatchedIndex ? "match-logic" : "no-logic x2"}
      >
        <img src={row.imgSrc} alt={row.imgSrc} width={25} height={25} />
        {showLabel && (
          <div className="asset_tab_label">
            <div style={{ fontSize: 14, color: "var(--fnt)" }}>{row.title}</div>
            {row.typ === "forex" ? (
              <div
                style={{
                  fontSize: 11,
                  color: "#7C808A",
                  textTransform: "capitalize",
                }}
              >
                {row.typ + "-" + row.chartType}
              </div>
            ) : (
              <div
                style={{
                  fontSize: 11,
                  color: "#7C808A",
                  textTransform: "capitalize",
                }}
              >
                {row.typ}
              </div>
            )}
          </div>
        )}
        {showCloseIcon && showLabel && (
          <CloseOutlined
            onClick={handleClose}
            style={{
              fontSize: 12,
              color: "#9197A4",
              marginLeft: "auto",
              cursor: "pointer",
            }}
          />
        )}
      </div>
    );
  };

  //assetprofit card fir mobile

  // const AssetProfitCard = ({ row }) => {
  //   return (
  //     <Card
  //       style={{
  //         background: "rgb(39 42 50)",
  //         borderRadius: 8,
  //         padding: 8,
  //         // width: ,
  //         color: "white",
  //         minHeight: "64px",
  //       }}
  //     >
  //       <div className="display-2 gap-10">
  //         <div>
  //           <div style={{ fontSize: 12, color: "#a7a7a7" }}>Asset</div>

  //           <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
  //             <img src={row.imgSrc} alt={row.title} width={12} height={12} />

  //             <span
  //               style={{
  //                 fontSize: 16,
  //                 fontWeight: 600,
  //                 color: "white",
  //               }}
  //               className="asset-prf"
  //             >
  //               {row.title}
  //             </span>
  //           </div>
  //         </div>

  //         {/* RIGHT SIDE */}
  //         <div>
  //           <div style={{ fontSize: 12, color: "#a7a7a7" }}>Profit</div>
  //           <div
  //             style={{
  //               fontSize: 18,
  //               fontWeight: 600,
  //               color: "#00ff80",
  //             }}
  //             className="asset-prf"

  //           >
  //             {percent}%
  //           </div>
  //         </div>
  //       </div>
  //     </Card>
  //   );
  // };

  // Time frame
  const TimeBtn = ({ label, active }) => {
    return (
      <div
        style={{
          background: active ? "rgb(255 204 0 / 71%)" : "#000",
          padding: "6px 14px",
          borderRadius: 4,
          fontSize: 12,
          fontWeight: 600,
          color: active ? "#fff" : "#ccc",
          cursor: "pointer",
          opacity: active ? 1 : 0.5,
        }}
        className="time-framer"
      >
        {label}
      </div>
    );
  };
  const [quantity, setQuantity] = useState(100); // Default bet amount

  const payout = (quantity * percent) / 100;
  //currency pair

  const items2 = sideArr.map((row, index) => ({
    key: row.key,
    label: (
      <div
        style={{
          // display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
          display: index === 0 && isMobile ? "none" : "flex",
        }}
        className="side_icon"
      >
        {row.icon}
        <span style={{ fontSize: "12px", marginTop: "4px", color: "#fff" }}>
          {row.name}
        </span>
      </div>
    ),
  }));

  //dropdown animation

  const controls = useAnimation(); // 👈 control animation manually

  useEffect(() => {
    if (profileDrop) {
      controls.start("visible");
      getNotifications();
    }
  }, [profileDrop]);

  const handleOpenChange = (open) => {
    if (open) {
      // force animation replay smoothly
      setAnimateKey((prev) => prev + 1);
    }
    setProfileDrop(open);
  };
  const dropdownVariants = {
    hidden: {
      opacity: 0,
      rotateX: -90,
      transformOrigin: "top center",
      y: -20,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      rotateX: 0,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.45,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.08,
      },
    },
    exit: {
      opacity: 0,
      rotateX: -90,
      y: -10,
      scale: 0.95,
      transition: { duration: 0.3, ease: "easeIn" },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10, scale: 0.98 },
    visible: { opacity: 1, y: 0, scale: 1 },
  };

  const handleNavigate = () => {
    message.success("successfully Logged out");
    setProfileDrop(false);
    localStorage.clear();
    // window.location.href = "https://login.pcgroup.ltd/";
  };

  /*Profile Drop Down */
  const dropdownContent = (
    <AnimatePresence mode="wait">
      {profileDrop && (
        <motion.div
          key={animateKey}
          variants={dropdownVariants}
          initial="hidden"
          animate="visible"
          // exit="exit"
          style={{
            width: "600px",
            background: "var(--bg-mn)",
            border: "2px solid #f7a60047",
            borderRadius: 8,
            display: "flex",
            overflow: "hidden",
            transformOrigin: "top center",
            perspective: 1000, // for 3D flip effect
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 4px 32px",
          }}
        >
          {/* Profile Header */}
          <motion.div
            style={{
              background: "var(--bg-mn)",
              color: "#fff",
              borderRight: "2px solid #f7a60047",
              width: "50%",
              padding: 20,
            }}
          >
            <motion.div variants={itemVariants}>
              <motion.div variants={itemVariants}>
                <div className="display-cls-1">
                  <div className="display-1 dropdown-media a3 mt-10">
                    <div
                      className="header-trd blance-tx text-center cursor"
                      ref={ref1}
                    >
                      <div style={{ display: "flex", gap: "5px" }}>
                        <div> $ </div>
                        {wallet?.balance
                          ? Number(wallet?.balance - escrow).toFixed(2)
                          : "0.00"}
                      </div>
                      {/* <Progress percent={100} /> */}
                      <div className="hr-bar ar3" />
                      <div className="net-pnl ar3">
                        Net P/L: ${" "}
                        {wallet?.profit
                          ? Number(wallet?.profit).toFixed(3)
                          : "0.00"}
                      </div>
                    </div>
                  </div>

                  <Button
                    className="deposit dropdown-media a4 text-center"
                    variant="outlined"
                    onClick={() => {
                      setActiveDrawer("deposit");
                      showDrawer();
                    }}
                  >
                    Deposit
                  </Button>
                </div>
              </motion.div>
            </motion.div>

            {/* Notification list */}
            <motion.div variants={itemVariants}>
              <h3
                style={{
                  marginBottom: 10,
                  marginTop: 0,
                  fontWeight: 600,
                  color: "#f7a500ff",
                }}
              >
                Notifications
              </h3>
            </motion.div>
            <motion.div>
              <div
                style={{
                  maxHeight: 150, // around 4 items height
                  overflowY: "auto",
                  scrollbarWidth: "thin", // for Firefox
                  scrollbarColor: "var(--active3) transparent",
                }}
                className="notification-scroll"
              >
                {notifications.length === 0 ? (
                  <motion.p
                    variants={itemVariants}
                    style={{ color: "var(--fnt)", textAlign: "center" }}
                  >
                    No new notifications
                  </motion.p>
                ) : (
                  notifications.map((item) => (
                    <motion.div
                      key={item.id}
                      variants={itemVariants}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "var(--active3)",
                        padding: "8px 10px",
                        borderRadius: 8,
                        marginBottom: 8,
                      }}
                    >
                      <span style={{ fontSize: 14, color: "var(--fnt)" }}>
                        {item?.type === "support"
                          ? `${item?.count} Unread Message from Admin`
                          : ""}
                      </span>
                      <CloseCircleOutlined
                        onClick={() => handleClose()}
                        style={{
                          color: "#ff4d4f",
                          fontSize: 16,
                          cursor: "pointer",
                          marginLeft: 8,
                        }}
                      />
                    </motion.div>
                  ))
                )}
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            style={{
              color: "#fff",
              width: "50%",
              padding: "15px 30px",
              // display: "flex",
              // flexDirection: "column",
              // gap: "8px",
            }}
          >
            <motion.div variants={itemVariants}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* <Avatar
                        size={48}
                        icon={<UserOutlined />}
                        style={{ marginRight: 12 }}
                    /> */}
                <div>
                  <div className="test display-1">
                    {profile?.name ? profile.name : "Demo User"}
                    <VerifyIcon />
                  </div>
                  <div className="text-mail">
                    {profile?.email ? profile.email : "demo@gmail.com"}
                  </div>
                </div>
                <label class="switch">
                  <span class="sun">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <g fill="#ffd43b">
                        <circle r="5" cy="12" cx="12"></circle>
                        <path d="m21 13h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm-17 0h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm13.66-5.66a1 1 0 0 1 -.66-.29 1 1 0 0 1 0-1.41l.71-.71a1 1 0 1 1 1.41 1.41l-.71.71a1 1 0 0 1 -.75.29zm-12.02 12.02a1 1 0 0 1 -.71-.29 1 1 0 0 1 0-1.41l.71-.66a1 1 0 0 1 1.41 1.41l-.71.71a1 1 0 0 1 -.7.24zm6.36-14.36a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm0 17a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm-5.66-14.66a1 1 0 0 1 -.7-.29l-.71-.71a1 1 0 0 1 1.41-1.41l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.29zm12.02 12.02a1 1 0 0 1 -.7-.29l-.66-.71a1 1 0 0 1 1.36-1.36l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.24z"></path>
                      </g>
                    </svg>
                  </span>
                  <span class="moon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 384 512"
                    >
                      <path d="m223.5 32c-123.5 0-223.5 100.3-223.5 224s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"></path>
                    </svg>
                  </span>
                  <input
                    type="checkbox"
                    className="input"
                    checked={theme === "dark"} // true if dark, false if light
                    onChange={toggleTheme}
                  />

                  <span class="slider"></span>
                </label>
              </div>
            </motion.div>
            <motion.div variants={itemVariants}>
              <Divider
                style={{ margin: "12px 0", backgroundColor: "#3B404F" }}
              />
            </motion.div>
            <motion.div variants={itemVariants}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "5px",
                }}
                className="p-10"
              >
                <div>
                  <div className="p-date">Date registered</div>
                  <div className="p-date-txt">8 Apr 2025</div>
                </div>
                <div>
                  <div className="p-date">User ID</div>
                  <div className="p-date-txt display-1">
                    177595946
                    <div className="display-1 cursor copy-clr">
                      <svg
                        width="15"
                        height="17"
                        viewBox="0 0 15 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.99805 17H2.65625C1.19155 17 0 15.8084 0 14.3438V5.3457C0 3.881 1.19155 2.68945 2.65625 2.68945H8.99805C10.4627 2.68945 11.6543 3.881 11.6543 5.3457V14.3438C11.6543 15.8084 10.4627 17 8.99805 17ZM2.65625 4.01758C1.92397 4.01758 1.32812 4.61342 1.32812 5.3457V14.3438C1.32812 15.076 1.92397 15.6719 2.65625 15.6719H8.99805C9.73033 15.6719 10.3262 15.076 10.3262 14.3438V5.3457C10.3262 4.61342 9.73033 4.01758 8.99805 4.01758H2.65625ZM14.3105 12.6836V2.65625C14.3105 1.19155 13.119 0 11.6543 0H4.2832C3.91641 0 3.61914 0.297272 3.61914 0.664062C3.61914 1.03085 3.91641 1.32812 4.2832 1.32812H11.6543C12.3866 1.32812 12.9824 1.92397 12.9824 2.65625V12.6836C12.9824 13.0504 13.2797 13.3477 13.6465 13.3477C14.0133 13.3477 14.3105 13.0504 14.3105 12.6836Z"
                          fill="var(--fnt)"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div variants={itemVariants}>
              <Divider
                style={{ margin: "12px 0", backgroundColor: "#3B404F" }}
              />
            </motion.div>

            <motion.div variants={itemVariants}>
              <Upload {...props}>
                <p className="display-1 p-profile">
                  <svg
                    width="22"
                    height="17"
                    viewBox="0 0 22 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.2734 2.27319H14.4851L13.3163 0.309606C13.2019 0.117623 12.995 0 12.7716 0H9.09548C8.87205 0 8.66512 0.117623 8.55084 0.309606L7.38201 2.27319H5.48261V1.84041C5.48261 1.49039 5.19883 1.20662 4.84881 1.20662H2.50367C2.15358 1.20662 1.86987 1.49039 1.86987 1.84041V2.27319H1.59378C0.713495 2.27319 0 2.98676 0 3.86691V15.4062C0 16.2864 0.713495 17 1.59371 17H20.2734C21.1536 17 21.8672 16.2864 21.8672 15.4062V3.86691C21.8672 2.98676 21.1536 2.27319 20.2734 2.27319ZM10.9335 14.1731C8.4281 14.1731 6.39705 12.142 6.39705 9.63649C6.39705 7.13111 8.4281 5.09999 10.9335 5.09999C13.439 5.09999 15.47 7.13111 15.47 9.63649C15.47 12.142 13.439 14.1731 10.9335 14.1731ZM19.279 5.55896H17.293C16.943 5.55896 16.6592 5.27518 16.6592 4.92509C16.6592 4.57499 16.943 4.29122 17.293 4.29122H19.279C19.6292 4.29122 19.9129 4.57499 19.9129 4.92509C19.9129 5.27518 19.6291 5.55896 19.279 5.55896Z"
                      fill="#8E9199"
                    />
                    <path
                      d="M10.9348 12.8057C12.6851 12.8057 14.104 11.3868 14.104 9.63649C14.104 7.88619 12.6851 6.46729 10.9348 6.46729C9.18453 6.46729 7.76562 7.88619 7.76562 9.63649C7.76562 11.3868 9.18453 12.8057 10.9348 12.8057Z"
                      fill="#8E9199"
                    />
                  </svg>
                  Upload a Photo
                </p>
              </Upload>
            </motion.div>
            {/* <motion.div variants={itemVariants}>
              <p className="display-1 p-profile">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.0006 11.9996C18.4476 11.9996 18.0006 12.4477 18.0006 12.9996V20.9999C18.0006 21.5509 17.5525 21.9999 17.0006 21.9999H3.0001C2.44802 21.9999 2.00013 21.5509 2.00013 20.9999V6.99936C2.00013 6.44838 2.44802 5.99939 3.0001 5.99939H11.0004C11.5534 5.99939 12.0004 5.55132 12.0004 4.99942C12.0004 4.44734 11.5534 3.99927 11.0004 3.99927H3.0001C1.34605 3.99927 0 5.34532 0 6.99936V20.9999C0 22.6539 1.34605 24 3.0001 24H17.0006C18.6547 24 20.0007 22.6539 20.0007 20.9999V12.9996C20.0007 12.4466 19.5536 11.9996 19.0006 11.9996Z"
                    fill="#8E9199"
                  />
                  <path
                    d="M9.37713 11.0886C9.30718 11.1586 9.26012 11.2476 9.24016 11.3435L8.53317 14.8798C8.50021 15.0437 8.55221 15.2127 8.67014 15.3317C8.76517 15.4267 8.89317 15.4776 9.02428 15.4776C9.05614 15.4776 9.08928 15.4747 9.12224 15.4677L12.6574 14.7608C12.7554 14.7406 12.8443 14.6937 12.9134 14.6236L20.8256 6.71136L17.2905 3.17639L9.37713 11.0886Z"
                    fill="#8E9199"
                  />
                  <path
                    d="M23.2707 0.731301C22.2958 -0.243767 20.7097 -0.243767 19.7355 0.731301L18.3516 2.11526L21.8867 5.65041L23.2707 4.26627C23.7427 3.79531 24.0027 3.16723 24.0027 2.49924C24.0027 1.83125 23.7427 1.20318 23.2707 0.731301Z"
                    fill="#8E9199"
                  />
                </svg>
                Personal Data
              </p>
            </motion.div> 
            <motion.div variants={itemVariants}>
              <p className="display-1 p-profile">
                <svg
                  width="21"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.5001 1.44324C17.0566 1.44324 21.5627 5.9494 21.5627 11.5058C21.5627 17.0623 17.0566 21.5685 11.5001 21.5685C5.94366 21.5685 1.4375 17.0623 1.4375 11.5058C1.4375 5.9494 5.94366 1.44324 11.5001 1.44324ZM9.41048 14.7743L6.94691 12.3086C6.5272 11.8887 6.52711 11.2039 6.94691 10.784C7.36679 10.3642 8.05467 10.3668 8.47149 10.784L10.2083 12.5222L14.5289 8.20157C14.9488 7.78169 15.6337 7.78169 16.0535 8.20157C16.4733 8.62136 16.4727 9.30686 16.0535 9.72615L10.9694 14.8103C10.5501 15.2295 9.86457 15.2301 9.44477 14.8103C9.43298 14.7985 9.4216 14.7865 9.41048 14.7743Z"
                    fill="#8E9199"
                  />
                </svg>
                Verify Account
              </p>
            </motion.div>
            <motion.div variants={itemVariants}>
              <p className="display-1 p-profile">
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5 0C4.71007 0 0 4.71007 0 10.5C0 16.2899 4.71007 21 10.5 21C16.2899 21 21 16.2899 21 10.5C21 4.71007 16.2899 0 10.5 0ZM15.0938 11.3749H11.3749V15.0938C11.3749 15.5768 10.9831 15.9687 10.5 15.9687C10.0169 15.9687 9.62505 15.5768 9.62505 15.0938V11.3749H5.90625C5.42319 11.3749 5.0313 10.9831 5.0313 10.5C5.0313 10.0169 5.42319 9.62505 5.90625 9.62505H9.62505V5.90625C9.62505 5.42319 10.0169 5.0313 10.5 5.0313C10.9831 5.0313 11.3749 5.42319 11.3749 5.90625V9.62505H15.0938C15.5768 9.62505 15.9687 10.0169 15.9687 10.5C15.9687 10.9831 15.5768 11.3749 15.0938 11.3749Z"
                    fill="#8E9199"
                  />
                </svg>
                Deposit Funds
              </p>
            </motion.div>
            <motion.div variants={itemVariants}>
              <p className="display-1 p-profile">
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 11 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.96301 9.08516C7.17818 8.65144 6.34379 8.32099 5.51766 7.97815C5.0385 7.77987 4.58 7.54856 4.17519 7.22636C3.37797 6.59024 3.53081 5.55758 4.46434 5.14864C4.7287 5.03298 5.00546 4.99581 5.28634 4.97928C6.36857 4.92145 7.39711 5.11973 8.37607 5.59062C8.86349 5.82607 9.02459 5.75172 9.18982 5.24365C9.3633 4.70666 9.50788 4.16141 9.66897 3.6203C9.77637 3.2568 9.64419 3.01722 9.30134 2.86439C8.67348 2.58763 8.0291 2.38936 7.35167 2.28196C6.46771 2.14565 6.46771 2.14152 6.46358 1.25343C6.45945 0.00183587 6.45945 0.00183585 5.20373 0.00183585C5.02198 0.00183585 4.84023 -0.00229481 4.65848 0.00183585C4.07192 0.0183585 3.97279 0.121625 3.95627 0.71231C3.948 0.976672 3.95627 1.24103 3.95214 1.50953C3.94801 2.29435 3.94387 2.28196 3.19209 2.55459C1.3746 3.21549 0.251062 4.45469 0.131273 6.43741C0.0238759 8.19294 0.940883 9.37844 2.38248 10.2417C3.27058 10.7746 4.25367 11.0885 5.19547 11.5057C5.56309 11.6668 5.9142 11.8527 6.21987 12.1088C7.12449 12.8565 6.95926 14.0998 5.88529 14.5707C5.31112 14.8227 4.70392 14.8846 4.08019 14.8061C3.11774 14.6863 2.1966 14.4344 1.32917 13.9841C0.821094 13.7198 0.67239 13.79 0.498902 14.3394C0.350198 14.8144 0.218017 15.2935 0.0858359 15.7727C-0.0917826 16.4171 -0.0256924 16.5699 0.589776 16.8715C1.3746 17.2515 2.21313 17.4456 3.06817 17.5819C3.73734 17.6893 3.75799 17.7182 3.76626 18.4122C3.77039 18.7261 3.77039 19.0442 3.77452 19.3581C3.77865 19.7547 3.96866 19.986 4.37759 19.9942C4.84023 20.0025 5.30699 20.0025 5.76963 19.9901C6.14965 19.9819 6.34379 19.7753 6.34379 19.3912C6.34379 18.9616 6.36444 18.5279 6.34792 18.0983C6.32727 17.6604 6.51728 17.4374 6.9386 17.3217C7.90931 17.0573 8.73544 16.5369 9.37156 15.7603C11.1395 13.6124 10.4662 10.4689 7.96301 9.08516Z"
                    fill="#8E9199"
                  />
                </svg>
                Withdraw Funds
              </p>
            </motion.div>*/}
            <motion.div variants={itemVariants}>
              <p className="display-1 p-profile">
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21C16.299 21 21 16.299 21 10.5Z"
                    fill="#8E9199"
                  />
                  <path
                    d="M6.875 8.04369C6.875 7.58481 7.02233 7.11987 7.31698 6.64887C7.61164 6.17788 8.04157 5.78779 8.60676 5.47862C9.17201 5.16963 9.83138 5.01506 10.5849 5.01489C11.2852 5.01489 11.9035 5.14412 12.4398 5.40257C12.9761 5.66103 13.3904 6.01246 13.6826 6.45688C13.97 6.88538 14.1226 7.39005 14.1209 7.906C14.1209 8.3166 14.0375 8.67648 13.8707 8.98566C13.7144 9.28108 13.514 9.55103 13.2766 9.78628C13.0472 10.011 12.6354 10.389 12.0412 10.9203C11.9024 11.0445 11.7706 11.1764 11.6463 11.3152C11.5605 11.4099 11.4864 11.5146 11.4254 11.6269C11.3786 11.7171 11.341 11.8118 11.3131 11.9095C11.2865 12.0037 11.2466 12.1692 11.1935 12.4058C11.1017 12.9082 10.8143 13.1594 10.3313 13.1593C10.2146 13.1623 10.0984 13.1421 9.98954 13.0998C9.88069 13.0575 9.78133 12.994 9.69724 12.913C9.52572 12.7489 9.43998 12.505 9.44003 12.1812C9.44003 11.7754 9.50282 11.4241 9.62838 11.1271C9.74816 10.839 9.91737 10.574 10.1284 10.3441C10.3948 10.0632 10.6753 9.79597 10.9689 9.54347C11.278 9.27301 11.5014 9.06892 11.6392 8.93119C11.7759 8.79474 11.893 8.63988 11.9869 8.47107C12.0809 8.30284 12.1295 8.11309 12.1282 7.9204C12.131 7.73592 12.094 7.55301 12.0196 7.38418C11.9452 7.21535 11.8352 7.06459 11.6971 6.94222C11.4096 6.67665 11.0389 6.54382 10.5849 6.54371C10.0535 6.54371 9.6622 6.67769 9.41108 6.94566C9.15995 7.21363 8.94738 7.60852 8.77337 8.13032C8.60911 8.67651 8.29756 8.9496 7.8387 8.9496C7.71094 8.95216 7.58404 8.92802 7.46613 8.87874C7.34822 8.82946 7.24189 8.75611 7.15395 8.6634C6.96798 8.47251 6.875 8.26594 6.875 8.04369ZM10.411 15.9851C10.1271 15.9891 9.85194 15.8871 9.63933 15.6989C9.41943 15.5081 9.30952 15.2413 9.30961 14.8982C9.30653 14.7551 9.33329 14.6129 9.38817 14.4806C9.44305 14.3484 9.52486 14.2291 9.62838 14.1302C9.7312 14.0283 9.85349 13.9482 9.98795 13.8946C10.1224 13.8411 10.2663 13.8152 10.411 13.8184C10.5534 13.8164 10.6947 13.8429 10.8266 13.8964C10.9585 13.95 11.0784 14.0294 11.179 14.1301C11.2797 14.2308 11.3591 14.3507 11.4126 14.4826C11.4661 14.6145 11.4926 14.7559 11.4905 14.8982C11.4905 15.2364 11.3818 15.5021 11.1644 15.6952C10.959 15.8838 10.6898 15.9874 10.411 15.9851Z"
                    fill="#1C2233"
                  />
                </svg>
                Contact Support
              </p>
            </motion.div>
            {/* <motion.div variants={itemVariants}>
              <p className="display-1 p-profile">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.3751 12.5097H13.1259C12.7809 12.5097 12.5009 12.7896 12.5009 13.1346C12.5009 13.4796 12.8277 13.7208 13.0946 13.987L14.8313 15.7237C13.5271 16.8298 11.8448 17.5035 10 17.5035C6.28546 17.5035 3.20961 14.7994 2.61343 11.2542H0.0874837C0.70366 16.1849 4.90186 20.0031 10 20.0031C12.5353 20.0031 14.8463 19.0558 16.6067 17.4991L18.3971 19.2895C18.7339 19.6263 19.0301 20.0088 19.3751 20.0088C19.72 20.0088 20 19.7288 20 19.3838V13.1346C20 13.059 20 12.5097 19.3751 12.5097ZM0.624902 7.49905H6.87412C7.21909 7.49905 7.49905 7.21909 7.49905 6.87412C7.49905 6.52915 7.17222 6.28794 6.90536 6.02173L5.16869 4.28507C6.47291 3.17895 8.1552 2.50529 9.99997 2.50529C13.7145 2.50529 16.7904 5.20935 17.3865 8.75451H19.9125C19.2963 3.82389 15.0981 0.00562092 10 0.00562092C7.46467 0.00562092 5.15373 0.953007 3.39333 2.50971L1.60291 0.719281C1.26608 0.382451 0.969869 0 0.624902 0C0.279935 0 0 0.279967 0 0.624935V6.87415C0 6.94977 0 7.49905 0.624902 7.49905Z"
                    fill="#8E9199"
                  />
                </svg>
                Balance History
              </p>
            </motion.div> */}
            <motion.div variants={itemVariants}>
              <p className="display-1 p-profile">
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.1197 18.2864C11.9535 18.3278 11.784 18.3646 11.6158 18.3956C11.1761 18.4774 10.8854 18.9002 10.9668 19.3403C11.0069 19.5568 11.1299 19.7372 11.2968 19.8549C11.4689 19.976 11.6879 20.0307 11.911 19.9892C12.1113 19.952 12.3132 19.9083 12.5113 19.8588C12.9455 19.7508 13.21 19.3109 13.1017 18.8769C12.9936 18.4426 12.5541 18.1783 12.1197 18.2864Z"
                    fill="#9CA1A8"
                  />
                  <path
                    d="M18.1023 7.42518C18.1591 7.59624 18.2675 7.73588 18.4043 7.83237C18.6073 7.97531 18.8729 8.02341 19.1263 7.93961C19.5512 7.79853 19.7814 7.34038 19.6408 6.91572C19.5768 6.72214 19.5057 6.52794 19.43 6.33885C19.2638 5.92334 18.7925 5.72104 18.3767 5.88725C17.9614 6.05337 17.7591 6.52482 17.9254 6.94047C17.989 7.09939 18.0486 7.26252 18.1023 7.42518Z"
                    fill="#9CA1A8"
                  />
                  <path
                    d="M14.743 17.1284C14.6001 17.2228 14.4526 17.3141 14.304 17.3997C13.9162 17.6233 13.7834 18.119 14.007 18.5065C14.0677 18.612 14.1485 18.6981 14.2417 18.764C14.4916 18.9399 14.8311 18.9662 15.1137 18.8034C15.2904 18.7015 15.4661 18.5931 15.6363 18.4805C16.0096 18.2339 16.1123 17.7312 15.8656 17.3578C15.6189 16.9843 15.1164 16.8817 14.743 17.1284Z"
                    fill="#9CA1A8"
                  />
                  <path
                    d="M20.1512 9.68804C20.1336 9.24081 19.7569 8.89271 19.3095 8.91018C18.8627 8.92781 18.5143 9.30463 18.5319 9.75169C18.5386 9.92262 18.5403 10.0961 18.5364 10.2669C18.5301 10.5473 18.6673 10.7973 18.8805 10.9476C19.0075 11.037 19.1616 11.0911 19.3287 11.095C19.7759 11.1049 20.1466 10.7501 20.1565 10.3027C20.1609 10.0987 20.1592 9.89195 20.1512 9.68804Z"
                    fill="#9CA1A8"
                  />
                  <path
                    d="M17.978 14.997C17.6194 14.7279 17.112 14.801 16.8434 15.1589C16.7406 15.296 16.6322 15.4314 16.5213 15.5618C16.2315 15.9024 16.2724 16.4139 16.613 16.704C16.6324 16.7204 16.652 16.7355 16.6724 16.7498C17.0109 16.9885 17.4815 16.9336 17.7552 16.6124C17.8877 16.4568 18.0168 16.2951 18.1397 16.1313C18.4083 15.7734 18.3356 15.2656 17.978 14.997Z"
                    fill="#9CA1A8"
                  />
                  <path
                    d="M19.1599 12.0682C18.7329 11.9343 18.2782 12.172 18.1444 12.599C18.0932 12.7621 18.0364 12.9261 17.9751 13.0866C17.8406 13.44 17.9695 13.8288 18.265 14.0372C18.3192 14.0753 18.3789 14.1075 18.4438 14.1321C18.8619 14.2916 19.33 14.0818 19.4894 13.6636C19.5621 13.4727 19.6296 13.2777 19.6907 13.0838C19.8243 12.6567 19.5868 12.2021 19.1599 12.0682Z"
                    fill="#9CA1A8"
                  />
                  <path
                    d="M8.5789 18.4021C7.85446 18.272 7.15952 18.0505 6.50054 17.7416C6.49274 17.7375 6.48577 17.7329 6.47758 17.7291C6.32229 17.656 6.16726 17.5777 6.017 17.4959C6.01648 17.4953 6.01552 17.4949 6.0147 17.4946C5.73901 17.3428 5.46994 17.1748 5.20854 16.9908C1.39688 14.3057 0.480405 9.02023 3.16562 5.20861C3.74951 4.38009 4.4561 3.68888 5.24385 3.14104C5.25356 3.13428 5.26326 3.12757 5.27288 3.12076C8.04878 1.20809 11.818 1.07919 14.7656 3.04464L14.1325 3.95934C13.9565 4.21393 14.0648 4.39946 14.3729 4.37173L17.1228 4.12554C17.4313 4.09781 17.6158 3.83095 17.5328 3.53303L16.7944 0.872426C16.7117 0.574155 16.5001 0.538453 16.3239 0.793005L15.6893 1.70987C13.5262 0.257817 10.9318 -0.295873 8.35667 0.150666C8.09731 0.195554 7.84159 0.250494 7.58937 0.314447C7.58742 0.314793 7.58587 0.31501 7.58431 0.315356C7.57456 0.31774 7.56468 0.320902 7.55519 0.323546C5.33462 0.893786 3.39721 2.18891 2.01474 4.03676C2.00308 4.05058 1.99108 4.0641 1.98008 4.07914C1.93411 4.14105 1.88848 4.2044 1.84381 4.26774C1.77076 4.37156 1.69875 4.47797 1.62986 4.58439C1.62123 4.59721 1.61465 4.61025 1.60711 4.62321C0.46628 6.39104 -0.0839863 8.43482 0.0103823 10.5155C0.010599 10.5224 0.010209 10.5293 0.0103823 10.5363C0.0195245 10.7395 0.0356426 10.9456 0.0575233 11.1485C0.0586931 11.1615 0.0615961 11.1739 0.0638058 11.187C0.0864231 11.391 0.114803 11.5955 0.150375 11.7999C0.511905 13.8856 1.4958 15.7625 2.97012 17.2228C2.97355 17.2263 2.9771 17.23 2.98057 17.2335C2.98178 17.2349 2.98312 17.2356 2.98429 17.2368C3.3804 17.6275 3.81125 17.9889 4.27517 18.3156C5.48922 19.1711 6.8411 19.7366 8.29294 19.9971C8.73345 20.0763 9.15426 19.783 9.23329 19.3427C9.31227 18.9021 9.01929 18.481 8.5789 18.4021Z"
                    fill="#9CA1A8"
                  />
                  <path
                    d="M9.58554 3.53174C9.22319 3.53174 8.92969 3.8255 8.92969 4.18734V10.7189L14.9033 13.807C14.9995 13.8567 15.1024 13.8802 15.2037 13.8802C15.441 13.8802 15.6702 13.751 15.7867 13.5255C15.9528 13.2038 15.8271 12.8085 15.5053 12.6423L10.2407 9.92055V4.18734C10.2406 3.8255 9.94746 3.53174 9.58554 3.53174Z"
                    fill="#9CA1A8"
                  />
                </svg>
                Trading History
              </p>
            </motion.div>
            <motion.div variants={itemVariants} onClick={handleNavigate}>
              <p className="display-1 p-profile">
                <LogoutOutlined
                  style={{ color: "rgb(148, 153, 160)", fontSize: "21px" }}
                />
                Log Out
              </p>
            </motion.div>
            {/* <motion.div variants={itemVariants}>
              <p className="display-1 p-profile">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.9033 7.82833L17.3366 7.62917C17.2074 7.23167 17.0482 6.84833 16.8624 6.48417L17.8299 5.23833C18.2216 4.73417 18.1758 4.0225 17.7282 3.58917L16.4157 2.27667C15.9782 1.825 15.2665 1.78 14.7614 2.17083L13.5172 3.13833C13.153 2.9525 12.7697 2.79333 12.3713 2.66417L12.1722 1.1C12.0972 0.4725 11.5646 0 10.9338 0H9.06704C8.43618 0 7.90366 0.4725 7.82866 1.0975L7.62948 2.66417C7.23113 2.79333 6.84778 2.95167 6.4836 3.13833L5.23855 2.17083C4.7352 1.78 4.0235 1.825 3.58932 2.2725L2.27676 3.58417C1.82508 4.0225 1.77924 4.73417 2.17092 5.23917L3.13846 6.48417C2.95179 6.84833 2.79345 7.23167 2.66428 7.62917L1.10005 7.82833C0.47252 7.90333 0 8.43583 0 9.06667V10.9333C0 11.5642 0.47252 12.0967 1.09755 12.1717L2.66428 12.3708C2.79345 12.7683 2.95262 13.1517 3.13846 13.5158L2.17092 14.7617C1.77924 15.2658 1.82508 15.9775 2.27259 16.4108L3.58515 17.7233C4.0235 18.1742 4.73436 18.2192 5.23938 17.8283L6.48444 16.8608C6.84862 17.0475 7.23197 17.2067 7.62948 17.335L7.82866 18.8983C7.90366 19.5275 8.43618 20 9.06704 20H10.9338C11.5646 20 12.0972 19.5275 12.1722 18.9025L12.3713 17.3358C12.7689 17.2067 13.1522 17.0475 13.5164 16.8617L14.7623 17.8292C15.2665 18.2208 15.9782 18.175 16.4115 17.7275L17.7241 16.415C18.1758 15.9767 18.2216 15.2658 17.8299 14.7608L16.8624 13.5158C17.049 13.1517 17.2082 12.7683 17.3366 12.3708L18.9 12.1717C19.5275 12.0967 20 11.5642 20 10.9333V9.06667C20.0008 8.43583 19.5283 7.90333 18.9033 7.82833ZM10.0004 14.1667C7.70282 14.1667 5.83358 12.2975 5.83358 10C5.83358 7.7025 7.70282 5.83333 10.0004 5.83333C12.298 5.83333 14.1673 7.7025 14.1673 10C14.1673 12.2975 12.298 14.1667 10.0004 14.1667Z"
                    fill="#8E9199"
                  />
                </svg>
                Settings
              </p>
            </motion.div>
            <motion.div variants={itemVariants}>
              <Divider
                style={{ margin: "8px 0", backgroundColor: "#3B404F" }}
              />
            </motion.div>
            <motion.div variants={itemVariants}>
              <p className="display-1 p-profile">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.96751 18.2738H2.49186C2.03335 18.2738 1.66125 17.9016 1.66125 17.4432V2.4919C1.66125 2.03339 2.03339 1.66129 2.49186 1.66129H9.96751C10.4268 1.66129 10.7981 1.29001 10.7981 0.830685C10.7981 0.371355 10.4268 0 9.96751 0H2.49186C1.11801 0 0 1.11805 0 2.4919V17.4431C0 18.817 1.11801 19.935 2.49186 19.935H9.96751C10.4268 19.935 10.7981 19.5637 10.7981 19.1044C10.7981 18.6451 10.4268 18.2738 9.96751 18.2738Z"
                    fill="#8E9199"
                  />
                  <path
                    d="M19.7495 9.37609L14.6993 4.39233C14.3737 4.07004 13.8471 4.07422 13.5248 4.40065C13.2025 4.72708 13.2059 5.25286 13.5332 5.57515L17.1422 9.13685H7.47123C7.0119 9.13685 6.64062 9.50813 6.64062 9.96746C6.64062 10.4268 7.0119 10.7981 7.47123 10.7981H17.1422L13.5332 14.3598C13.2059 14.6821 13.2034 15.2079 13.5248 15.5343C13.6876 15.6988 13.9019 15.7818 14.1162 15.7818C14.3272 15.7818 14.5382 15.7021 14.6993 15.5426L19.7495 10.5588C19.9074 10.4027 19.9971 10.19 19.9971 9.96742C19.9971 9.7449 19.9082 9.53309 19.7495 9.37609Z"
                    fill="#8E9199"
                  />
                </svg>
                Log Out
              </p>
            </motion.div> */}
          </motion.div>

          {/* <motion.div
                        style={{
                            color: "#fff",
                            width: "40%",
                            padding: "15px 30px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                        }}
                    >
                        {[
                            "Upload a Photo",
                            "Personal Data",
                            "Verify Account",
                            "Deposit Funds",
                            "Withdraw Funds",
                            "Trading History",
                            "Settings",
                            "Log Out",
                        ].map((label, i) => (
                            <motion.p
                                key={label}
                                variants={itemVariants}
                                className="display-1 p-profile cursor"
                                style={{ margin: 0 }}
                            >
                                {label}
                            </motion.p>
                        ))}
                    </motion.div> */}
        </motion.div>
      )}
    </AnimatePresence>
  );

  //dropdown animation
  const handleOpenChangeacc = (open) => {
    if (open) setAnimKey((prev) => prev + 1); // trigger animation replay
    setAccDrop(open);
  };

  /*Account Drop */
  const accDropContent = (
    <AnimatePresence mode="wait">
      {accDrop && (
        <motion.div
          key={animKey}
          variants={dropdownVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          style={{
            width: "700px",
            background: "var(--bg-mn)",
            border: "2px solid #00ae3333",
            borderRadius: 8,
            display: "flex",
            overflow: "hidden",
            transformOrigin: "top center",
            perspective: 1000,
          }}
        >
          {/* Profile Header */}
          <motion.div
            variants={itemVariants}
            style={{
              width: "50%",
              background: "var(--bg-mn)",
              color: "#fff",
              borderRight: "2px solid #00ae3333",
            }}
          >
            <Card
              bordered={false}
              style={{
                background: "var(--bg-mn)",
                color: "#fff",
                // marginBottom: 12,
                width: "100%",
                height: demoAcc && 390,
              }}
            >
              {demoAcc ? (
                <motion.div variants={itemVariants} className="p-10">
                  <div className="p-10">
                    <div className="display-3 gap-15 mt-20 ">
                      <div className="eq-txt v2">Investment</div>
                      <Divider
                        style={{
                          backgroundColor: "#484C5A",
                          minWidth: "auto",
                          height: "2px",
                        }}
                      />
                      <div className="eq-amt v2">$ 20,442.14</div>
                    </div>
                    <div className="display-3 gap-15  ">
                      <div className="eq-txt v2">Available</div>
                      <Divider
                        style={{
                          backgroundColor: "#484C5A",
                          minWidth: "auto",
                          height: "2px",
                          margin: "18px 0",
                        }}
                      />
                      <div className="eq-amt v2">$ 3,785.79</div>
                    </div>
                  </div>
                </motion.div>
              ) : (
                <>
                  <motion.div variants={itemVariants} className="p-10">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="acc-h display-1">
                        MARGIN LEVEL
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7Z"
                            fill="#8E9199"
                          />
                          <path
                            d="M4.58594 5.36246C4.58594 5.05654 4.68416 4.74658 4.88059 4.43258C5.07703 4.11858 5.36365 3.85853 5.74045 3.65241C6.11728 3.44642 6.55686 3.34337 7.05918 3.34326C7.52605 3.34326 7.93825 3.42941 8.2958 3.60171C8.65335 3.77402 8.92952 4.00831 9.12432 4.30459C9.31591 4.59026 9.41769 4.9267 9.41657 5.27067C9.41657 5.5444 9.36097 5.78432 9.24977 5.99044C9.14552 6.18738 9.01197 6.36735 8.85367 6.52419C8.70073 6.67398 8.4262 6.92598 8.0301 7.28019C7.93755 7.36301 7.84966 7.4509 7.76684 7.54345C7.70962 7.6066 7.66017 7.67637 7.61954 7.75127C7.58832 7.81139 7.56324 7.87451 7.54467 7.93966C7.52691 8.00248 7.50033 8.11277 7.46493 8.27052C7.40372 8.60548 7.21212 8.77294 6.89014 8.77288C6.81231 8.77489 6.73487 8.7614 6.6623 8.73321C6.58973 8.70501 6.52349 8.66268 6.46743 8.60866C6.35308 8.49928 6.29592 8.33666 6.29596 8.12079C6.29596 7.85029 6.33782 7.61604 6.42152 7.41805C6.50138 7.22598 6.61418 7.04933 6.75484 6.89609C6.93247 6.7088 7.11949 6.53065 7.31517 6.36231C7.52125 6.18201 7.67021 6.04595 7.76205 5.95413C7.85322 5.86316 7.93125 5.75992 7.99387 5.64738C8.05652 5.53523 8.08897 5.40873 8.08804 5.28027C8.08994 5.15728 8.06524 5.03534 8.01564 4.92279C7.96604 4.81024 7.89271 4.70973 7.80066 4.62814C7.609 4.4511 7.36184 4.36255 7.05918 4.36247C6.70491 4.36247 6.44407 4.4518 6.27666 4.63044C6.10924 4.80909 5.96753 5.07234 5.85152 5.42021C5.74201 5.78434 5.53431 5.9664 5.22841 5.9664C5.14323 5.96811 5.05863 5.95202 4.98002 5.91916C4.90142 5.88631 4.83053 5.83741 4.7719 5.7756C4.64793 5.64834 4.58594 5.51063 4.58594 5.36246ZM6.94327 10.6567C6.75401 10.6594 6.57056 10.5914 6.42882 10.4659C6.28223 10.3388 6.20895 10.1608 6.20901 9.93215C6.20696 9.83673 6.2248 9.74192 6.26138 9.65377C6.29797 9.56561 6.35251 9.48604 6.42152 9.42011C6.49007 9.35219 6.5716 9.29879 6.66124 9.26309C6.75088 9.22738 6.8468 9.21011 6.94327 9.2123C7.03817 9.21092 7.13239 9.2286 7.22033 9.2643C7.30828 9.29999 7.38817 9.35296 7.45528 9.42009C7.52238 9.48721 7.57534 9.56711 7.611 9.65507C7.64667 9.74303 7.66433 9.83725 7.66293 9.93215C7.66293 10.1576 7.59046 10.3347 7.44552 10.4635C7.30863 10.5892 7.12912 10.6583 6.94327 10.6567Z"
                            fill="#1C2233"
                          />
                        </svg>
                      </div>
                      <div className="margin-lvl">498%</div>
                    </div>
                  </motion.div>
                  <motion.div variants={itemVariants} className="p-10">
                    <Divider
                      style={{
                        margin: "12px 0",
                        backgroundColor: "#1BA136",
                        height: "4px",
                      }}
                    />
                  </motion.div>
                  <motion.div variants={itemVariants} className="p-10">
                    <div className="pos-cls">
                      Positions will be closed at 50%
                    </div>
                  </motion.div>

                  <motion.div
                    variants={{
                      hidden: { opacity: 0 },
                      visible: {
                        opacity: 1,
                        transition: {
                          staggerChildren: 0.2, // 👈 controls delay between items
                          delayChildren: 0.25, // optional slight delay
                        },
                      },
                    }}
                    initial="hidden"
                    animate="visible"
                  >
                    <motion.div variants={itemVariants}>
                      <div className="display-3 gap-15">
                        <div className="eq-txt">Equity</div>

                        <Divider
                          style={{
                            backgroundColor: "#484C5A",
                            minWidth: "auto",
                            height: "2px",
                            margin: "18px 0",
                          }}
                        />
                        <div className="eq-amt">$ 18,875.77</div>
                      </div>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <div className="display-3 gap-15 mt-20 ">
                        <div className="eq-txt v2">Balance</div>
                        <Divider
                          style={{
                            backgroundColor: "#484C5A",
                            minWidth: "auto",
                            height: "2px",
                          }}
                        />
                        <div className="eq-amt v2">$ 20,442.14</div>
                      </div>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <div className="display-3 gap-15  ">
                        <div className="eq-txt v2">Margin</div>
                        <Divider
                          style={{
                            backgroundColor: "#484C5A",
                            minWidth: "auto",
                            height: "2px",
                            margin: "18px 0",
                          }}
                        />
                        <div className="eq-amt v2">$ 3,785.79</div>
                      </div>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <div className="display-3 gap-15  ">
                        <div className="eq-txt v2">Investment</div>
                        <Divider
                          style={{
                            backgroundColor: "#484C5A",
                            minWidth: "auto",
                            height: "2px",
                            margin: "18px 0",
                          }}
                        />
                        <div className="eq-amt v2">$ 0.00</div>
                      </div>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <div className="display-3 gap-15  ">
                        <div className="eq-txt v2">Available</div>
                        <Divider
                          style={{
                            backgroundColor: "#484C5A",
                            minWidth: "auto",
                            height: "2px",
                            margin: "18px 0",
                          }}
                        />
                        <div className="eq-amt v2">$ 15,089.95</div>
                      </div>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <div className="display-3 gap-15  ">
                        <div className="eq-txt v2">Net P/L</div>
                        <Divider
                          style={{
                            backgroundColor: "#484C5A",
                            minWidth: "auto",
                            height: "2px",
                            margin: "18px 0",
                          }}
                        />
                        <div className="eq-amt v2" style={{ color: "#D64C39" }}>
                          -$ 1,566.37
                        </div>
                      </div>
                    </motion.div>
                  </motion.div>
                </>
              )}
            </Card>
          </motion.div>

          {/* Menu Items */}
          <motion.div
            variants={itemVariants}
            style={{
              width: "50%",
              color: "#fff",
              // display: "flex",
              // flexDirection: "column",
              // justifyContent: "center",
            }}
          >
            <motion.div variants={itemVariants}>
              <div
                className="display-5 real-prac cursor"
                id={!demoAcc && "active-real"}
                onClick={() => {
                  setDemoAcc(false);
                }}
              >
                <div className="real-txt">
                  REAL ACCOUNT
                  <div className="real-amt">$ 20,442.14</div>
                </div>
                <div className="display-1 gap-1">
                  <svg
                    width="39"
                    height="40"
                    viewBox="0 0 39 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 5C0 2.23858 2.23858 0 5 0H39V40H5C2.23858 40 0 37.7614 0 35V5Z"
                      fill="#484D5B"
                    />
                    <path
                      d="M21.6309 12.249C21.512 12.1301 21.3605 12.0491 21.1957 12.0163C21.0308 11.9835 20.8599 12.0004 20.7046 12.0647C20.5493 12.129 20.4165 12.2379 20.3231 12.3777C20.2298 12.5175 20.1799 12.6818 20.1799 12.8499V15.8249C17.7384 15.8503 15.4054 16.8371 13.6869 18.5715C11.9683 20.3059 11.0029 22.6479 11 25.0895V26.6193C11.0001 26.8018 11.0588 26.9793 11.1676 27.1258C11.2763 27.2723 11.4293 27.3799 11.6039 27.4328C11.6836 27.4571 11.7666 27.4695 11.85 27.4693C11.9899 27.4693 12.1277 27.4347 12.251 27.3687C12.3744 27.3027 12.4796 27.2072 12.5572 27.0908C15.8041 22.2207 18.9177 21.8729 20.1798 21.9742V25.0895C20.1798 25.2576 20.2297 25.4219 20.3231 25.5617C20.4165 25.7014 20.5492 25.8104 20.7045 25.8747C20.8598 25.939 21.0307 25.9558 21.1956 25.923C21.3605 25.8902 21.5119 25.8093 21.6308 25.6904L27.751 19.5702C27.8299 19.4913 27.8926 19.3976 27.9353 19.2945C27.978 19.1914 28 19.0809 28 18.9692C28 18.8576 27.978 18.7471 27.9353 18.644C27.8926 18.5409 27.8299 18.4472 27.751 18.3683L21.6309 12.249Z"
                      fill="#9C9FA6"
                    />
                  </svg>
                  <div className="deep-btn">Deposit</div>
                </div>
              </div>
            </motion.div>

            <motion.div variants={itemVariants}>
              <div
                className="display-5 real-prac cursor"
                id={demoAcc && "active-demo"}
                onClick={() => {
                  setDemoAcc(true);
                }}
              >
                <div className="real-txt">
                  PRACTICE ACCOUNT
                  <div className="real-amt">$ 10,384.05</div>
                </div>
                <div className="display-1 gap-1">
                  {/* <svg width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 5C0 2.23858 2.23858 0 5 0H39V40H5C2.23858 40 0 37.7614 0 35V5Z" fill="#484D5B" />
                            <path d="M21.6309 12.249C21.512 12.1301 21.3605 12.0491 21.1957 12.0163C21.0308 11.9835 20.8599 12.0004 20.7046 12.0647C20.5493 12.129 20.4165 12.2379 20.3231 12.3777C20.2298 12.5175 20.1799 12.6818 20.1799 12.8499V15.8249C17.7384 15.8503 15.4054 16.8371 13.6869 18.5715C11.9683 20.3059 11.0029 22.6479 11 25.0895V26.6193C11.0001 26.8018 11.0588 26.9793 11.1676 27.1258C11.2763 27.2723 11.4293 27.3799 11.6039 27.4328C11.6836 27.4571 11.7666 27.4695 11.85 27.4693C11.9899 27.4693 12.1277 27.4347 12.251 27.3687C12.3744 27.3027 12.4796 27.2072 12.5572 27.0908C15.8041 22.2207 18.9177 21.8729 20.1798 21.9742V25.0895C20.1798 25.2576 20.2297 25.4219 20.3231 25.5617C20.4165 25.7014 20.5492 25.8104 20.7045 25.8747C20.8598 25.939 21.0307 25.9558 21.1956 25.923C21.3605 25.8902 21.5119 25.8093 21.6308 25.6904L27.751 19.5702C27.8299 19.4913 27.8926 19.3976 27.9353 19.2945C27.978 19.1914 28 19.0809 28 18.9692C28 18.8576 27.978 18.7471 27.9353 18.644C27.8926 18.5409 27.8299 18.4472 27.751 18.3683L21.6309 12.249Z" fill="#9C9FA6" />
                        </svg> */}
                  <div className="deep-btn">Top Up</div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  const uploadImage = async () => {
    try {
      if (!imageFile) {
        return message.error("Please upload an image");
      }

      const formData = new FormData();
      formData.append("image", imageFile);

      const { data } = await Axios.post("/uploadimage", formData, {
        headers: {
          Authorization: localStorage.getItem("nzanzi"),
        },
      });
      if (data?.success) {
        const payload = {
          image: data?.result,
        };
        const { data: resp } = await Axios.post(
          "/users/updateprofile",
          payload,
          {
            headers: {
              Authorization: localStorage.getItem("nzanzi"),
            },
          },
        );
        if (resp?.success) {
          getProfile();
        } else {
          message.error(resp?.message);
        }
      } else {
        message.error(data?.message);
      }
      setImageFile(null);
    } catch (e) {
      setImageFile(null);
      message.error(e?.response?.data?.message);
    }
  };
  const getProfile = async () => {
    try {
      const { data } = await Axios.post(
        "/users/profile",
        {},
        {
          headers: {
            Authorization: localStorage.getItem("nzanzi"),
          },
        },
      );
      if (data?.success) {
        setProfile(data?.result);
      } else {
        setProfile({});
      }
    } catch (error) {
      setProfile({});
    }
  };
  useEffect(() => {
    if (imageFile) {
      uploadImage();
    }
  }, [imageFile]);
  useEffect(() => {
    if (localStorage.getItem("nzanzi")) {
      getProfile();
      getWallet();
    }
  }, []);

  // // show bell + black avatar briefly
  // useEffect(() => {
  //   const showInterval = setInterval(() => {
  //     setShowBell(true);
  //     setTimeout(() => setShowBell(false), 2000); // hide after 2s
  //   }, 3000); // show every 8s
  //   return () => clearInterval(showInterval);
  // }, []);

  const handleMobileMenuClick = (item) => {
    setActiveComponent(item.component); // Load the selected component
  };

  return (
    <>
      <Layout
        className="mobile-bg"
        style={{ height: "100vh", background: "var(--bg-mn)" }}
      >
        {/* <Header
          ref1={ref1}
          ref2={ref2}
          ref3={ref3}
          tabs={tabs}
          itemVariants={itemVariants}
          notifications={notifications}
        /> */}
        <Header
          style={{
            background: "var(--bg-mn)",
            padding: "10px 10px",
            height: "80px",
            borderBottom: "1px solid #3B4253",
          }}
          className="header-cls mobile-bg "
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            className="header-desk"
          >
            <div className="display-1 logo-add">
              <div className="logo-head display-1">
                {isMobile ? (
                  <>
                    {/* <div style={{ textAlign: "center" }}>

                    <span
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: "#fff",
                        textAlign: "center",
                        display: "block",
                      }}
                    >
                      {activeTabType === "crypto" && "Trade"}
                      {activeTabType === "forex" && "Forex CFD"}
                      {activeTabType === "future" && "Future"}
                      {activeTabType === "forex" && (
                        <div
                          style={{
                            fontSize: 12,
                            color: "#9ca3af",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >

                          {currencyPair}


                        </div>
                      )}
                    </span>


                  </div> */}
                    <div
                      style={{
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        lineHeight: 1.2,
                      }}
                    >
                      <span
                        style={{
                          fontSize: 16,
                          fontWeight: 600,
                          color: "#fff",
                        }}
                      >
                        {activeTabType === "crypto" && "Trade"}
                        {activeTabType === "forex" && "Forex CFD"}
                        {activeTabType === "future" && "Future"}
                      </span>

                      {activeTabType === "forex" && (
                        <span
                          style={{
                            fontSize: 12,
                            color: "#9ca3af",
                            marginTop: 2,
                          }}
                        >
                          {localStorage.getItem("currencyPair")
                            ? localStorage.getItem("currencyPair").toUpperCase()
                            : "AUDCAD"}
                        </span>
                      )}
                    </div>
                  </>
                ) : (
                  <img src={theme === "light" ? logoLg : logo} alt="logo" style={{ height: "15px", width: '100%' }} />
                )}
              </div>

              <LayoutDrop>
                <Tooltip title="Chart Layout">
                  <motion.div
                    style={{
                      height: "100%",
                    }}
                    ref={ref3}
                    className="display-1 cursor lay-svg layout_mobile"
                    whileHover={{ scale: 1.08 }}
                    whileTap={{ scale: 0.97 }}
                  >
                    <GridIcon />
                  </motion.div>
                </Tooltip>
              </LayoutDrop>

              {/* 🔥 Tabs instead of Menu */}

              <AnimatePresence mode="sync" className="dsk-tabs">
                <motion.div
                  key={tabs.map((t) => t.key).join("-")} // unique key when tabs change
                  variants={tabVariants}
                  initial="hidden"
                  animate="visible"
                  // exit="exit"
                  className="plus-sym tab-dis-cons"
                >
                  <Tabs
                    type="editable-card"
                    onEdit={onEdit}
                    activeKey={activeKey}
                    onChange={setActiveKey}
                    style={{ flex: 1, marginLeft: "10px" }}
                    hideAdd
                    items={tabs.map((tab, i) => ({
                      label: CustomTabLabel(tab, i),
                      key: tab.key,
                      // children: tab.content,
                    }))}
                    className={`${tabs.length <= 1 && "one-tab"} head-tab`}
                    tabBarExtraContent={
                      tabs.length < 6 ? (
                        <Tooltip title="Open New Asset">
                          <motion.div
                            style={{
                              height: "100%",
                            }}
                            whileHover={{ scale: 1.08 }}
                            whileTap={{ scale: 0.97 }}
                          >
                            <Button
                              type="text"
                              style={{
                                marginLeft: "8px",
                                padding: "6px 8px",
                                minWidth: "30px",
                                // height: '32px',
                                color: "#9197A4",
                              }}
                              icon={
                                <div ref={ref2}>
                                  <AssetsAddIcon2 />
                                </div>
                              }
                              onClick={!isRunning && showDrawer}
                            />
                          </motion.div>
                        </Tooltip>
                      ) : null
                    }
                  />
                </motion.div>
              </AnimatePresence>
            </div>
            <div className="display-1 gap-15 ">
              <Dropdown
                dropdownRender={() => dropdownContent}
                trigger={["click"]}
                open={profileDrop}
                // onOpenChange={setProfileDrop}
                onOpenChange={handleOpenChange}
                className="profile_dropdown avathar-tabnon"
              >
                <div className="cursor display-1" id="cs">
                  <Badge
                    count={
                      <AnimatePresence>
                        {showBell && (
                          <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            // exit={{ opacity: 0, scale: 0.5 }}
                            transition={{ duration: 0.3 }}
                            className="bell_wrapper"
                          >
                            <BellFilled className="bell_icon" />
                          </motion.div>
                        )}
                      </AnimatePresence>
                    }
                  >
                    <motion.div
                      animate={{
                        backgroundColor: "#000",
                        filter: showBell
                          ? "grayscale(1) brightness(0.4)"
                          : "grayscale(0) brightness(1)",
                        scale: showBell ? 0.97 : 1,
                      }}
                      transition={{ duration: 0.5 }}
                      style={{
                        borderRadius: "50%",
                        width: 50,
                        height: 50,
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Avatar
                        size={50}
                        // src={
                        //   profile?.profile_image
                        //     ? profile?.profile_image
                        //     : profile?.name
                        // }
                        style={{
                          backgroundColor: "AccentColor",
                          verticalAlign: "middle",
                        }}
                      >
                        Demo
                      </Avatar>
                    </motion.div>
                  </Badge>
                  {/* <svg
                  width="14"
                  height="9"
                  viewBox="0 0 14 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.4258 0.761902H6.43353H1.0376C0.114239 0.761902 -0.347442 1.87763 0.306606 2.53169L5.28894 7.51399C6.08727 8.31232 7.38574 8.31232 8.18406 7.51399L10.0789 5.61918L13.1664 2.53169C13.8108 1.87763 13.3491 0.761902 12.4258 0.761902Z"
                    fill="#82858E"
                  />
                </svg> */}
                </div>
              </Dropdown>
              <Dropdown
                dropdownRender={() => accDropContent}
                trigger={["click"]}
                open={accDrop}
                destroyPopupOnHide={true}
              >
                <div className="display-1 dropdown-media media-blane ">
                  <div
                    className="header-trd blance-tx text-center cursor"
                    ref={ref1}
                  >
                    {isMobile ? (
                      <>
                        {/* <div onClick={showDrawerAccount}>
                          <div
                            style={{
                              display: "flex",
                              gap: "5px",
                              justifyContent: "center",
                              color: "#09a1cf",
                            }}
                          >
                            <div> $ </div>
                            {wallet?.balance
                              ? Number(wallet?.balance - escrow).toFixed(2)
                              : "0.00"}
                          </div>
                          <div className="hr-bar ar3" />
                          <div className="net-pnl ">
                            <div
                              className="demo"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "#888",
                                gap: "10px",
                                marginTop: "5px",
                              }}
                            >
                              <div style={{ textAlign: "center" }}>
                                Demo account
                              </div>
                              <DropDownIcon1 />
                            </div>
                          </div>
                        </div>
                        <div className="bottom-drawer">
                          <Drawer
                            title="Your accounts"
                            placement={"bottom"}
                            onClose={onCloseAccount}
                            open={openAccount}
                            closable={true}
                            getContainer={false}
                            closeIcon={
                              <CloseOutlined style={{ color: "#888" }} />
                            }
                          >
                            <div className="flex flex-col gap-5">
                              <ConfigProvider
                                theme={{
                                  token: {
                                    colorPrimary: "#0092e4",
                                  },
                                }}
                              >
                                <Radio.Group
                                  onChange={onChangeRadio}
                                  value={value}
                                  style={style}
                                  className="radio-design"
                                >
                                  <Radio value={1}>
                                    <div className="act-amt-mb cursor flex justify-between items-center w-80">
                                      <div className="act-tpy-mob display-1">
                                        Real account
                                      </div>
                                      <div>$17,071.33</div>
                                    </div>
                                  </Radio>
                                </Radio.Group>
                              </ConfigProvider>

                              {value === 1 && (
                                <div className="display-3 space-evenly gap-5 mt-10 mb-10">
                                  <Button
                                    type="primary"
                                    className="withdraw-btn w-1/2"
                                  >
                                    Withdraw
                                  </Button>
                                  <Button className="Deposit-btn w-1/2">
                                    Deposit
                                  </Button>
                                </div>
                              )}

                              <ConfigProvider
                                theme={{
                                  token: {
                                    colorPrimary: "#0092e4",
                                  },
                                }}
                              >
                                <Radio.Group
                                  onChange={onChangeRadio}
                                  value={value}
                                  style={style}
                                  className="radio-design"
                                >
                                  <Radio value={2}>
                                    <div className="act-amt-mb cursor flex justify-between items-center w-80">
                                      <div className="act-tpy-mob display-1">
                                        Demo account
                                      </div>
                                      <div>$17,071.33</div>
                                    </div>
                                  </Radio>
                                </Radio.Group>
                              </ConfigProvider>

                              {value === 2 && (
                                <div className="display-3 space-evenly gap-5 mt-10 mb-10">
                                  <Button className="top-up-btn w-1/2">
                                    Top up
                                  </Button>
                                </div>
                              )}
                            </div>
                          </Drawer>
                        </div> */}
                      </>
                    ) : (
                      <>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <div> $ </div>
                          {wallet?.balance
                            ? Number(wallet?.balance - escrow).toFixed(2)
                            : "0.00"}
                        </div>
                        <div className="hr-bar " />
                        <div className="net-pnl ">
                          Net P/L: ${" "}
                          {wallet?.profit
                            ? Number(wallet?.profit).toFixed(3)
                            : "0.00"}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Dropdown>
              {/* <Button
              className="deposit dropdown-media"
              variant="outlined"
              onClick={() => {
                showDrawer();
              }}
            >
              Deposit
            </Button> */}
            </div>
            <div className="profile-tab">
              {/* <Avatar
                size={50}
                src={
                  profile?.profile_image
                    ? profile?.profile_image
                    : profile?.name
                }
                icon={<UserOutlined />}
                style={{ backgroundColor: "transparent" }}
                onClick={() => {
                  // setDrawerOpen(true);
                  setOpenProfile(true);
                  setActiveKeyRoom("tradehistory");
                  setOpenPortfolioDrawer(false);
                  onClose();
                }}
              /> */}

              <MobileProfileDrawer
                open={openProfile}
                onClose={onCloseProfile}
                profile={profile}
                uploadProps={props}
                commonProps={commonProps}
              />
            </div>
            <div className="display-3 gap-15 app-tab">
              <div className="app-store">
                <div>
                  <AppstoreFilled
                    style={{ color: "#fff", fontSize: "20px", opacity: "0.8" }}
                    onClick={() => {
                      if (!isRunning) showDrawer();
                      setOpenPortfolioDrawer(false);
                      setCollapsedHistory(true);
                    }}
                  />
                </div>
              </div>
              <div className="history-store">
                <div>
                  <HistoryOutlined
                    style={{ color: "#fff", fontSize: "20px", opacity: "0.8" }}
                  // onClick={() => {
                  //   showPortfolioDrawer();
                  //   // setCollapsedHistory(false);
                  // }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div style={{ height: "50%" }} className="header-mob for-desk">
            <AnimatePresence mode="sync" className="">
              <motion.div
                key={tabs.map((t) => t.key).join("-")} // unique key when tabs change
                variants={tabVariants}
                initial="hidden"
                animate="visible"
                className="plus-sym tab-allow-cons"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Tabs
                  onEdit={onEdit}
                  activeKey={activeKey}
                  onChange={setActiveKey}
                  style={{
                    flex: activeFtpage?.typ === "future" ? 0 : 1,
                    marginLeft: !isMobile && "10px",
                  }}
                  hideAdd
                  items={tabs.map((tab, i) => ({
                    label: CustomTabLabel(tab, i, activeKey, onEdit),
                    key: tab.key,
                  }))}
                  className={`${tabs.length <= 1 && "one-tab"} head-tab`}
                  tabBarExtraContent={
                    tabs.length < 6 ? (
                      <Tooltip title="Open New Asset">
                        <motion.div
                          style={{
                            height: "100%",
                          }}
                          whileHover={{ scale: 1.08 }}
                          whileTap={{ scale: 0.97 }}
                        ></motion.div>
                      </Tooltip>
                    ) : null
                  }
                />

                <Button
                  type="text"
                  style={{
                    marginLeft: "8px",
                    padding: "6px 8px",
                    minWidth: "20px",
                    color: "#9197A4",
                  }}
                  className="mob-btn"
                  icon={
                    <div ref={ref2}>
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="7.33325"
                          y="0.333334"
                          width="4"
                          height="17.3333"
                          fill="#9197A4"
                        />
                        <rect
                          x="0.666626"
                          y="11"
                          width="4"
                          height="17.3333"
                          transform="rotate(-90 0.666626 11)"
                          fill="#9197A4"
                        />
                      </svg>
                    </div>
                  }
                  onClick={() => {
                    if (!isRunning) showDrawer();
                    setOpenPortfolioDrawer(false);
                    setCollapsedHistory(true);
                  }}
                />

                {activeFtpage?.typ === "future" && (
                  <div className="icon-tabs">
                    <div
                      className={`tab-icon ${mode === "chart" ? "active" : ""}`}
                      onClick={() => setMode("chart")}
                    >
                      <AreaChartOutlined
                        style={{ color: "var(--fnt)", fontSize: "20px" }}
                        size={"large"}
                      />
                    </div>

                    <div
                      className={`tab-icon ${mode === "placeorder" ? "active" : ""
                        }`}
                      onClick={() => setMode("placeorder")}
                    >
                      <ControlOutlined
                        style={{ color: "var(--fnt)", fontSize: "20px" }}
                      />
                    </div>
                  </div>
                )}
              </motion.div>
            </AnimatePresence>
          </div>
          {/* <div className="header-mob ar3 " >
            <div className="display-5 gap-5 framer-crd">

              <div style={{ width: "100%" }}>
                <AssetProfitCard
                  row={{
                    imgSrc: "https://cryptoicons.org/api/icon/btc/200",
                    title: "BTCUSDT",
                    profit: 88.0
                  }}
                />
              </div>


              <div style={{ width: "100%" }}>

                <Card
                  style={{
                    background: "rgb(39 42 50)",
                    borderRadius: 8,
                    padding: 8,
                    // width: ,
                    color: "white",
                    minHeight: "64px",
                  }}
                  bodyStyle={{ padding: 0 }}
                >
                  <div className="">Time Frame</div>

                  <div className="display-2 gap-5">
                    <TimeBtn label="1h" active={false} />
                    <TimeBtn label="15m" active={false} />
                    <TimeBtn label="5m" active={false} />
                    <TimeBtn label="1m" active={true} />
                  </div>
                </Card>
              </div>

            </div>
          </div> */}
          {/* <div className="display-5">
            <div style={{ fontSize: 12, color: '#a7a7a7' }}>Estimated Profit <span style={{ color: '#22c55e', fontWeight: '600', fontSize: 12, }}> +${payout.toFixed(2)} {percent}% </span></div>
            <div style={{ fontSize: 12, color: '#a7a7a7' }}>price <span style={{ color: "#fff" }}>$92412</span> </div>
          </div> */}
        </Header>

        <Layout style={{ background: "var(--bg-mn)" }}>
          <>
            {!isMobile && (
              <>
                <Sider
                  width={90}
                  style={{
                    background: "var(--bg-mn3)",
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                    borderTop: "2px solid #f7a60047",
                  }}
                >
                  <SideMenu
                    items={items2}
                    activeKey={activeKeyRoom}
                    onClick={handleMenuClick}
                    className="ant-side-li"
                    id="cs"
                  />
                </Sider>

                <Sider
                  trigger={null}
                  width={300}
                  collapsed={collapsed}
                  collapsedWidth={0}
                  style={{
                    background: "var(--bg-mn3)",
                    borderLeft: !collapsed && "1px solid #f7a60047",
                    borderTop: !collapsed && "1px solid #f7a60047",
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                  }}
                  className="sider layout-si"
                >
                  {multiLayerSidebar
                    .filter((item) => item.key === activeKeyRoom) // only show active component
                    .map((item) => item.component)}
                </Sider>
              </>
            )}
          </>
          <Layout style={{ padding: "0", background: "var(--bg-mn)" }}>
            <Content
              style={{
                padding: 0,
                margin: 0,
                minHeight: 280,
                borderRadius: 8,
                background: "var(--bg-mn)",
                color: "#fff",
                // marginBottom: "50px"
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
              className="mobile-bg"
            >
              {/* <LayoutGrid /> */}
              <TradeLayout setActiveTabType={setActiveTabType} />
              {!isMobilePoint && (
                <TabsWithAccordionHeader
                  collapsedHistory={collapsedHistory}
                  setCollapsedHistory={setCollapsedHistory}
                />
              )}
              {/* <TradeTable /> */}
              <Tour
                open={open}
                onClose={() => setOpen(false)}
                steps={steps}
                className="tour-tab"
                mask={{
                  style: {
                    boxShadow: "inset 0 0 15px #333",
                  },
                  color: "#404854b6",
                }}
                gap={{
                  offset: 8, // distance between element and popup
                  radius: 6, // rounded corners of highlight mask
                }}
                indicatorsRender={(current, total) => (
                  <span>
                    {current + 1} / {total}
                  </span>
                )}
                id="cs"
              />
              <DropDown />

              <div className="portfolio-tabs">
                <Drawer
                  placement="right"
                  closable={true}
                  onClose={onPortfolioClose}
                  open={openPortfolioDrawer}
                  getContainer={false}
                  closeIcon={
                    <RightCircleOutlined
                      className="close-drawer-icon"
                      style={{
                        color: "#ffffff",
                        fontSize: "25px",
                      }}
                    />
                  }
                  style={{
                    position: "absolute", // not fixed
                    height: "100%",
                  }}
                  className="dynamic-draw"
                  width="100%"
                >
                  <h6 className="back-btn">
                    <ArrowLeftOutlined
                      onClick={onPortfolioClose}
                      style={{
                        color: "currentColor",
                        fontSize: "18px",
                        cursor: "pointer",
                      }}
                    />{" "}
                    {/* Portfolio */}
                    History
                  </h6>
                  <TabsWithAccordionHeader
                    collapsedHistory={collapsedHistory}
                    setCollapsedHistory={setCollapsedHistory}
                  />
                </Drawer>
              </div>
              {/* <div className="portfolio-tabs">
                <Drawer
                  placement="right"
                  closable={true}
                  onClose={onOrderBookClose}
                  open={openShowOrderBook}
                  getContainer={false}
                  closeIcon={
                    <RightCircleOutlined
                      className="close-drawer-icon"
                      style={{
                        color: "#ffffff",
                        fontSize: "25px",
                      }}
                    />
                  }
                  style={{
                    position: "absolute", // not fixed
                    height: "100%",
                  }}
                  className="dynamic-draw"
                  width="100%"
                >
                  <h6 className="back-btn">
                    <ArrowLeftOutlined
                      onClick={onPortfolioClose}
                      style={{
                        color: "currentColor",
                        fontSize: "18px",
                        cursor: "pointer",
                      }}
                    />{" "}
                    Portfolio
                  </h6>
                  <OrderBookPanel />
                </Drawer>
              </div> */}
              <div className="display-2 pos-bot-mob ar33  ">
                <Tooltip title="coming soon" placement={placement}>
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    className={`menu-item ${activeTabType === "news" ? "bottom-active" : ""
                      }`}
                    onClick={() => {
                      setActiveMenu("news");
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="2"
                        y="1"
                        width="16.4348"
                        height="18"
                        rx="1.56524"
                        fill="white"
                      />
                      <rect
                        x="5.91304"
                        y="4.91304"
                        width="8.6087"
                        height="2.34783"
                        fill="black"
                      />
                      <rect
                        x="5.91304"
                        y="8.82609"
                        width="8.6087"
                        height="2.34783"
                        fill="black"
                      />
                      <rect
                        x="5.91304"
                        y="12.7391"
                        width="6.26087"
                        height="2.34783"
                        fill="black"
                      />
                    </svg>

                    <div style={{ textAlign: "center", color: "var(--fnt)" }}>
                      News
                    </div>
                  </div>
                </Tooltip>

                <div
                  className={`menu-item ${activeTabType === "crypto" ||
                    (activeTabType === "forex" && chartType === "binary")
                    ? "bottom-active"
                    : ""
                    }`}
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onClick={() => {
                    addAsset(
                      "BTC/USDT",
                      "crypto",
                      "binary",
                      `${consts.BackendUrl}/images/BTC.png`,
                      true,
                      true,
                    );
                    setActiveTabType("crypto");
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.27907 12.3721H1V14.0465H7.27907V15.7209L10.2093 13.2093L7.27907 9.86048V12.3721Z"
                      fill="white"
                    />
                    <path
                      d="M12.7211 6.51165H19.0001V8.18606H12.7211V9.86048L9.79083 7.34885L12.7211 4.00002V6.51165Z"
                      fill="white"
                    />
                  </svg>

                  <div style={{ textAlign: "center" }}>Binary</div>
                </div>

                <div
                  className={`menu-item ${activeTabType === "future" ? "bottom-active" : ""
                    }`}
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onClick={() => {
                    addAsset(
                      "SOL/USDT",
                      "future",
                      "trade",
                      "https://boapi.pcgroup.ltd/binaryTrade/images/SOL.png",
                      true,
                      true,
                    );
                    setActiveTabType("future");
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.0362 6.61687C15.8635 4.82503 14.3165 4.22471 12.3636 4.05409L12.3629 1.56859L10.85 1.56912L10.8507 3.98911C10.453 3.98926 10.0465 3.99722 9.64254 4.00538L9.64216 1.56936L8.13008 1.56969L8.13013 4.05448C7.80258 4.06125 7.48091 4.06742 7.16726 4.0677L7.16706 4.05999L5.08039 4.0598L5.08119 5.67563C5.08119 5.67563 6.1984 5.65405 6.17984 5.67463C6.79265 5.67466 6.99218 6.03038 7.05027 6.33736L7.0511 9.16887C7.09339 9.16909 7.14855 9.17083 7.21102 9.17937C7.16062 9.17945 7.10667 9.17913 7.0512 9.17962L7.05179 13.1463C7.02495 13.3391 6.91166 13.6467 6.48351 13.6475C6.50288 13.6647 5.38375 13.6475 5.38375 13.6475L5.08359 15.4544L7.05242 15.4538C7.41881 15.4542 7.77931 15.4603 8.13322 15.4624L8.13448 17.9762L9.64576 17.9761L9.6451 15.4889C10.0601 15.4974 10.4616 15.5006 10.8537 15.5001L10.8536 17.9759L12.3665 17.9753L12.3664 15.466C14.9098 15.3194 16.6899 14.6782 16.9104 12.2896C17.0884 10.3663 16.1834 9.50836 14.7395 9.162C15.6166 8.71513 16.1648 7.92802 16.0362 6.61687ZM13.9209 11.9925C13.9222 13.8711 10.7055 13.6582 9.68018 13.6594L9.67975 10.3288C10.7054 10.3288 13.9205 10.0331 13.9209 11.9925ZM13.2161 7.29359C13.216 9.00271 10.5334 8.80393 9.67932 8.80421L9.67866 5.78347C10.5327 5.7832 13.2155 5.51094 13.2161 7.29359Z"
                      fill="white"
                    />
                  </svg>

                  <div style={{ textAlign: "center", color: "var(--fnt)" }}>
                    Future
                  </div>
                </div>

                <div
                  className={`menu-item ${activeTabType === "forex" ? "bottom-active" : ""}`}
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onClick={() => {
                    setActiveTabType("forex");
                    addAsset(
                      "AUDCAD",
                      "forex",
                      "binary",
                      "https://boapi.pcgroup.ltd/binaryTrade/images/1761803290689_AUDCAD.png",
                      true,
                      true,
                    );
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.97778 8.86667L3 13.8444L4.18342 15.0889L7.97778 11.2945L10.7778 14.0945L15.0723 9.8L16.3778 11.0444L17 7.31111L13.2667 7L14.2 8.24444L10.7778 11.6667L7.97778 8.86667Z"
                      fill="white"
                    />
                  </svg>

                  <div style={{ textAlign: "center", color: "var(--fnt)" }}>
                    Forex
                  </div>
                </div>

                <div
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  className={`menu-item ${activeTabType === "me" ? "bottom-active" : ""
                    }`}
                  onClick={() => {
                    // setDrawerOpen(true);
                    setOpenProfile(true);
                    setActiveKeyRoom("tradehistory");
                    setOpenPortfolioDrawer(false);
                    onClose();
                    // setActiveMenu("me");
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.61111 2.00003C7.68121 2.00003 6.11111 3.57013 6.11111 5.50003C6.11111 7.42993 7.68121 9.00003 9.61111 9.00003C11.541 9.00003 13.1111 7.42993 13.1111 5.50003C13.1111 3.57013 11.541 2.00003 9.61111 2.00003Z"
                      fill="white"
                    />
                    <path
                      d="M15.2256 12.3661C14.0757 11.1986 12.5514 10.5556 10.9333 10.5556H9.06667C7.44864 10.5556 5.92426 11.1986 4.77439 12.3661C3.63016 13.5279 3 15.0615 3 16.6845C3 16.9422 3.20894 17.1511 3.46667 17.1511H16.5333C16.7911 17.1511 17 16.9422 17 16.6845C17 15.0615 16.3698 13.5279 15.2256 12.3661Z"
                      fill="white"
                    />
                  </svg>

                  <div style={{ textAlign: "center", color: "var(--fnt)" }}>
                    Me
                  </div>

                  {/* <MobileProfileDrawer
                    open={openProfile}
                    onClose={onCloseProfile}
                    profile={profile}
                    uploadProps={props}
                    commonProps={commonProps}
                  /> */}
                </div>
              </div>
            </Content>
          </Layout>
        </Layout>

        <Footer
          setCollapsed={setCollapsed}
          setActiveKeyRoom={setActiveKeyRoom}
          setOnOff={setOnOff}
          onOff={onOff}
        />
      </Layout>
    </>
  );
};

export default TradeRoom;
